export const NotificationSuccessIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="#4DB357"
    />
    <path
      d="M17.4215 8.68406L12.2716 13.8339L9.30154 10.8638L8.423 11.7423L12.2716 15.591L18.3 9.56375L17.4215 8.68406Z"
      fill="white"
    />
    <path
      d="M14.7518 8.26666L11.3865 11.632L12.2653 12.5107L15.6306 9.14545L14.7518 8.26666Z"
      fill="white"
    />
    <path
      d="M6.5788 11.2189L5.70001 12.0977L9.19328 15.5909L10.0721 14.7121L6.5788 11.2189Z"
      fill="white"
    />
  </svg>
);
